import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MitarbeiterControl from '@/components/MitarbeiterControl.vue'
import MaterialView from '@/views/Buero/MaterialView.vue'
import AlleAuftraegeView from '../views/AlleAuftraegeView.vue'
import UebersichtView from '../views/UebersichtView.vue'
import Arbeitszeiten from '../views/Buero/Arbeitszeiten.vue'
import AlleAufrägeerledigtView from '../views/AlleAufrägeerledigtView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/worker',
    name: 'worker',
    component: () => import(/* webpackChunkName: "about" */ '../views/Arbeiter/Worker.vue')
  },
  {
    path: '/worker/arbeitszeitworker',
    name: 'arbeitszeitworker',
    component: () => import(/* webpackChunkName: "about" */ '../views/Arbeiter/Arbeiterzeitworker.vue')
  },
  {
    path: '/worker/arbeitszeit',
    name: 'arbeitszeit',
    component: () => import(/* webpackChunkName: "about" */ '../views/Arbeiter/Arbeitezeit.vue')
  },

  {
    path: '/manage',  // Hauptpfad für die Manage-Seite
    component: () => import(/* webpackChunkName: "about" */ '../views/Bueromanage/MainView.vue'),
    redirect: '/manage/mitarbeiter',
    children: [
      {
        path: 'mitarbeiter',
        component: AlleAuftraegeView,  // Mitarbeiter-Komponente wird geladen
      },
      {
        path: 'mitarbeitererledigt',
        component: AlleAufrägeerledigtView,  // Mitarbeiter-Komponente wird geladen
      },
      {
        path: 'uebersicht',
        component: UebersichtView  // Material-Komponente wird geladen
      },
      {
        path: 'arbeitszeiten',
        component: Arbeitszeiten  // Material-Komponente wird geladen
      },
      {
        path: 'settings',  // Pfad für Settings
        component: () => import(/* webpackChunkName: "settings" */ '../views/Buero/Settings.vue'),
        redirect: '/manage/settings/mitarbeiter',
        children: [
          {
            path: 'mitarbeiter',
            component: MitarbeiterControl,  // Mitarbeiter-Komponente wird geladen
          },
          {
            path: 'material',
            component: MaterialView,  // Material-Komponente wird geladen
          },
        ],
      },
    ],
  },
  {
    path: '/uebersicht',
    name: 'uebersicht',
    component: () => import(/* webpackChunkName: "about" */ '../views/UebersichtView.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/neuermitarbeiter',
    name: 'neuermitarbeiter',
    // route level code-splitting
    component: () => import(/* webpackChunkName: "about" */ '../views/NewWorkerView.vue')
  }, 
  {
    path: '/alleauftraege/erledigt',
    name: 'alleauftraegeerledigt',
    component: () => import(/* webpackChunkName: "about" */ '../views/AlleAufrägeerledigtView.vue')
  }, 
  {
    path: '/alleauftraege',
    name: 'alleauftraege',
    component: () => import(/* webpackChunkName: "about" */ '../views/AlleAuftraegeView.vue')
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import(/* webpackChunkName: "about" */ '../views/ConfirmView.vue')
  }, 
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },  
  {
    path: '/app',
    name: 'app',
    component: () => import(/* webpackChunkName: "about" */ '../views/MainApp.vue')
  }, 
  {
    path: '/app/auftraege/:name',
    name: 'MitarbeiterDetail',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/ArbeiterView.vue')
  }, 
  {
    path: '/app/erledigt/:name',
    name: 'MitarbeiterErledigtDetail',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/ArbeitErledigtView.vue')
  }, 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
